import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { AdditionalServiceData, Amount, Product, Service } from '@mews-commander/data-access';

export const useGetServiceProductsCurrency = (products: Product[], service: Service) => {
    const {
        basePrice: { currency: serviceCurrency },
    } = service.data.value as AdditionalServiceData;

    const enterpriseCurrency = useCurrentEnterprise().defaultCurrencyCode;

    const hasSingleCurrency = pipe(
        products,
        array.every((p) => (p.pricing.value as Amount).currency === serviceCurrency)
    );

    return {
        hasSingleCurrency,
        originalCurrency: serviceCurrency,
        currency: hasSingleCurrency ? serviceCurrency : enterpriseCurrency,
    };
};
